import { useAppSelector } from 'app/hooks';
import { selectPlanEntitlements } from 'services/plan/planSelectors';

function usePlanEntitlement(
  key: string,
  features?: (string | number | boolean)[],
) {
  const planEntitlements = useAppSelector(selectPlanEntitlements);

  /* check the given entitlement key available on the plan entitlements or not */
  const isEntitlementAvailable = key in planEntitlements;

  /* get entitlement value if requested entitlement available on the plan entitlements */
  const entitlementValue = isEntitlementAvailable
    ? planEntitlements[key]
    : null;

  /* Check the requested feature available on the requested entitlements */
  let isEntitlementFeatureAvailable = false;
  if (entitlementValue && features) {
    isEntitlementFeatureAvailable = Array.isArray(entitlementValue)
      ? features.some((feature) => entitlementValue.includes(feature as string))
      : entitlementValue === features[0];
  }

  return {
    isEntitlementAvailable,
    isEntitlementFeatureAvailable,
    entitlementValue,
  };
}

export default usePlanEntitlement;
